export const APIPrincipalColumnImportList = [
    'BoardMident',
    'SchoolMident',
    'SchoolName',
    'PrincipalEmail',
    'PrincipalFirstName',
    'PrincipalLastName',
  ]

export const APIAdminColumnImportList = [
    'BoardMident',
    'SchoolMident',
    'SchoolName',
    'AdminEmail',
    'AdminFirstName',
    'AdminLastName',
  ]